import instituicaoFinanceiraList from '../instituicaoFinanceiraList'



const seguradoraList = () => {

    return instituicaoFinanceiraList.filter(linhaInstituicaoFinanceiraList => linhaInstituicaoFinanceiraList.seguradora === 'S')
}

export default seguradoraList